import {
  SCHEDULE_SELECT,
  SCHEDULE_RESET,
  SCHEDULE_INCLUDE_MESSAGE,
  SCHEDULE_FORM_FOCUSED,
  SCHEDULE_ONE_TIME
} from 'constants/ScheduleModal';

// ------------------------------------
// Actions
// ------------------------------------

export function selectContactForSchedule(contactId) {
  return {
    type: SCHEDULE_SELECT,
    payload: contactId
  };
}

export function resetContactForSchedule(contactId) {
  return {
    type: SCHEDULE_RESET,
    payload: contactId
  };
}

export function setScheduleFormFocus(isFocused) {
  return {
    type: SCHEDULE_FORM_FOCUSED,
    payload: isFocused
  };
}

export function toggleScheduleMessage(toggle) {
  return {
    type: SCHEDULE_INCLUDE_MESSAGE,
    payload: toggle
  };
}

export function scheduleOneTimeMeeting() {
  return {
    type: SCHEDULE_ONE_TIME
  };
}

export default {
  selectContactForSchedule,
  setScheduleFormFocus,
  toggleScheduleMessage,
  resetContactForSchedule,
  scheduleOneTimeMeeting
};
